import IConfig from 'app/config/Config'

export class Environment {
  constructor(config: IConfig) {
    this.config = config
  }

  config: IConfig
}
